import DocumentIcon2 from "../../../assets/Icons/DocumentIcon2";
import Card from "../../../components/Card";
const DocumentComponent = ({ text, documents, imageSelectHandler, stateUpdateHandler }) => {
  return (<div>
    <p className="font-Apparat font-[600] text-[12px] md:text-[20px] leading-[13.92px] md:leading-[40px]">
      {text}
    </p>
    <div className="flex">
      {documents?.map((doc, index) =>
        <Card
          className={"flex gap-[18px] items-center min-w-[100%] md:min-w-[376px] cursor-pointer"}
          key={index}
          onClick={() => {
            stateUpdateHandler("modalvisible", true);
            stateUpdateHandler("selectedDoc", doc);
          }}
        >
          <div className="bg-[#78666914] rounded-full md:rounded-[10px] px-[9px]
          py-[9px] md:px-[18px] md:py-[20px] col-span-1">
            <DocumentIcon2 className="w-[15px] md:w-[17px] h-[19px] md:h-[21px]" />
          </div>
          <div className="col-span-3 flex flex-col gap-[4px]">
            <p className="font-Apparat font-[600] text-[14px] md:text-[20px]  leading-[20px] md:leading-[24px] tracking-[-2%]">{text}</p>
            <div className="flex gap-[4px] items-center">
              <p className="font-Apparat font-[500] md:font-[600] text-[12px]  md:text-[16px] leading-[16px] md:leading-[19.2px] tracking-[-2%] text-[#42495250]">{doc.uplaodDate}</p>
              <p className="font-Apparat font-[500] md:font-[600] text-[12px]  md:text-[16px] leading-[16px] md:leading-[19.2px] tracking-[-2%] text-[#42495250]">{doc.size}</p>
            </div>
          </div>
        </Card>)}
    </div>
  </div>)
}
export default DocumentComponent;